<app-modal-dialog [show]="show" [title]="isEditMode ? 'Modificar asegurado' : 'Datos del asegurado'" [width]="600"
           [closeOnBackdrop]="!running"
           (closed)="close()">

    <form class="im-form" [formGroup]="form" (ngSubmit)="save()">

        <div class="im-field">
            <label for="im-policy">Póliza</label>
            <div class="im-select" *ngIf="!isPolicyFixed" [class.im-input--error]="isInvalid('policySequence')">
                <select id="im-policy" formControlName="policySequence">
                    <option value="" disabled>Seleccionar póliza</option>
                    <option *ngFor="let p of policies" [value]="p.sequence">{{ p.label }}</option>
                </select>
                <svg class="im-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <input *ngIf="isPolicyFixed" id="im-policy-fixed" type="text" [value]="selectedPolicyLabel"
                   readonly tabindex="-1" class="im-input--readonly">
            <p *ngIf="!isPolicyFixed && isInvalid('policySequence')" class="im-error">(*) Campo obligatorio</p>
        </div>

        <div class="im-field">
            <label for="im-name">Nombre</label>
            <input id="im-name" type="text" formControlName="name" maxlength="60"
                   placeholder="Nombre"
                   [class.im-input--error]="isInvalid('name')">
            <p *ngIf="isInvalid('name')" class="im-error">(*) Campo obligatorio</p>
        </div>

        <div class="im-field">
            <label for="im-first-surname">Primer apellido</label>
            <input id="im-first-surname" type="text" formControlName="firstSurname" maxlength="60"
                   placeholder="Primer apellido"
                   [class.im-input--error]="isInvalid('firstSurname')">
            <p *ngIf="isInvalid('firstSurname')" class="im-error">(*) Campo obligatorio</p>
        </div>

        <div class="im-field">
            <label for="im-last-name">Segundo apellido</label>
            <input id="im-last-name" type="text" formControlName="lastName" maxlength="60"
                   placeholder="Segundo apellido">
        </div>

        <div class="im-field">
            <label for="im-document-number">Número de documento</label>
            <input id="im-document-number" type="text" formControlName="documentNumber" maxlength="20"
                   placeholder="DNI/NIE" [readonly]="isEditMode" [tabindex]="isEditMode ? -1 : null"
                   [class.im-input--readonly]="isEditMode"
                   [class.im-input--error]="isInvalid('documentNumber')">
            <p *ngIf="isInvalid('documentNumber')" class="im-error">(*) Campo obligatorio</p>
        </div>

        <div class="im-field">
            <label for="im-phone">Teléfono</label>
            <div class="im-phone" [class.im-input--error]="isInvalid('phone') || isInvalid('phonePrefix')">
                <select class="im-phone-prefix" formControlName="phonePrefix"
                        aria-label="Prefijo telefónico">
                    <option *ngFor="let p of prefixes" [value]="p.id">+{{ p.id }} {{ p.itemName }}</option>
                </select>
                <input id="im-phone" type="tel" formControlName="phone" [maxlength]="phoneMaxLength"
                       placeholder="Número de teléfono">
            </div>
            <p *ngIf="isInvalid('phone') || isInvalid('phonePrefix')" class="im-error">
                <ng-container *ngIf="form.get('phonePrefix').errors?.required">(*) Selecciona un prefijo</ng-container>
                <ng-container *ngIf="form.get('phone').errors?.required">(*) Campo obligatorio</ng-container>
                <ng-container *ngIf="form.get('phone').errors?.pattern">{{ phoneErrorDescription }}</ng-container>
            </p>
        </div>

        <div class="im-field">
            <label for="im-relationship">Relación con el asegurado</label>
            <div class="im-select" [class.im-input--error]="isInvalid('relationship')">
                <select id="im-relationship" formControlName="relationship">
                    <option value="" disabled>Seleccionar</option>
                    <option *ngFor="let r of relationships" [value]="r.value">{{ r.label }}</option>
                </select>
                <svg class="im-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <p *ngIf="isInvalid('relationship')" class="im-error">(*) Campo obligatorio</p>
        </div>

        <div class="im-field">
            <label for="im-birth">Fecha de nacimiento</label>
            <div class="im-date" [class.im-input--error]="isInvalid('birthDate')">
                <input id="im-birth" type="text" formControlName="birthDate" placeholder="dd/mm/yyyy" maxlength="10">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                    <rect x="3" y="5" width="18" height="16" rx="2"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                    <line x1="8" y1="3" x2="8" y2="7"/>
                    <line x1="16" y1="3" x2="16" y2="7"/>
                </svg>
            </div>
            <p *ngIf="isInvalid('birthDate')" class="im-error">
                <ng-container *ngIf="form.get('birthDate').errors?.required">(*) Campo obligatorio</ng-container>
                <ng-container *ngIf="form.get('birthDate').errors?.pattern">(*) Formato dd/mm/yyyy</ng-container>
                <ng-container *ngIf="form.get('birthDate').errors?.underage">(*) Solo pueden darse de alta asegurados mayores de edad.</ng-container>
            </p>
        </div>

        <div class="im-field">
            <label for="im-email">Correo electrónico</label>
            <input id="im-email" type="email" formControlName="email" maxlength="128"
                   placeholder="ejemplo@correo.com"
                   [class.im-input--error]="isInvalid('email')">
            <p *ngIf="isInvalid('email')" class="im-error">
                <ng-container *ngIf="form.get('email').errors?.required">(*) Campo obligatorio</ng-container>
                <ng-container *ngIf="form.get('email').errors?.pattern">(*) Correo no válido</ng-container>
            </p>
        </div>

    </form>

    <div modal-footer class="im-actions">
        <button type="button" class="im-cancel" (click)="close()" [disabled]="running">
            Cancelar
        </button>
        <button type="button" class="im-save" (click)="save()" [disabled]="running">
            {{ running ? 'Guardando...' : (isEditMode ? 'Guardar cambios' : 'Guardar y continuar') }}
        </button>
    </div>

</app-modal-dialog>
